export interface RetryWithValidationOptions<T> {
    operation: () => Promise<T>
    validator: (result: T) => boolean
    maxRetries: number
    onFailure: (lastError: Error) => T
}

export async function retryWithValidation<T>({
    operation,
    validator,
    maxRetries,
    onFailure,
}: RetryWithValidationOptions<T>): Promise<T> {
    let lastError: Error | null = null
    let attempt = 0

    while (attempt < maxRetries) {
        try {
            const result = await operation()

            if (!validator(result)) {
                attempt++
                continue
            }

            return result
        } catch (error) {
            lastError = error as Error
            attempt++

            if (attempt >= maxRetries) {
                break
            }
        }
    }

    return onFailure(
        lastError ?? new Error(`Operation failed after ${maxRetries} attempts`),
    )
}
